import { render, staticRenderFns } from "./insuranceTable.vue?vue&type=template&id=0c8b1cea&scoped=true&"
import script from "./insuranceTable.vue?vue&type=script&lang=js&"
export * from "./insuranceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8b1cea",
  null
  
)

export default component.exports